import styled from 'styled-components'
import {
  breakpoint,
  Heading3,
  ParagraphLargeStyles,
  BlockPaddingBoth
} from '../../../layout/mixins'
import Img from 'gatsby-image'

export const Section = styled(BlockPaddingBoth)`
  
`

export const Grid = styled.div`
  display: flex;
  flex-direction: column;

  ${breakpoint.up('desktop')`
    flex-direction: row;
  `}
`

export const GridItem = styled.div`
  position: relative;
  width: 100%;
  
  ${breakpoint.up('desktop')`
    width: 50%;
  `}
`

export const TextItem = styled(GridItem)`
  display: flex;
  justify-content: center;
  order: 1;

  ${breakpoint.up('tablet')`
    order: ${({ reverse }) => reverse ? '2' : '1'};
  `}
`

export const ImageItem = styled(GridItem)`
  position: relative;
  order: 2;

  ${breakpoint.up('tablet')`
    order: ${({ reverse }) => reverse ? '1' : '2'};
  `}
`

export const ImageIndex = styled.div`
  position: absolute;
  bottom: 0;
  ${({ reverse }) => reverse && 'right: 0;'}
  ${({ reverse }) => reverse === false && 'left: 0;'}
  width: 3.89rem;
  height: 3.89rem;
  background-color: ${({ theme }) => theme.colorAccent};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.11rem;
  font-weight: 500;
`

export const Image = styled(Img)`
  width: 100%;
`

export const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: ${({ theme }) => theme.gutterLarge};

  ${breakpoint.up('desktop')`
    padding-bottom: 0;
    max-width: 28rem;

    ${({ reverse, theme }) => reverse ? `
      padding-left: ${theme.gutterLarge};
    ` : `
      padding-right: ${theme.gutterLarge}
    `}
  `}
`

export const Title = styled(Heading3)`
  margin-bottom: ${({ theme }) => theme.gutter};
`

export const BodyText = styled.div`
  p {
    ${ParagraphLargeStyles}

    ${({ theme }) => `
      @media (min-width: ${theme.breakpoints.tablet}) {
        // font-size: 1.33rem;
      }
    `}
  }
`
